// data/Home/HomeLogoSlider.jsx
import React from "react";
import Slider from "../../components/Slider/Slider";

const items = [
  { src: "/assets/tools_logo/react.svg", alt: "React" },
  { src: "/assets/tools_logo/typescript.svg", alt: "TypeScript" },
  { src: "/assets/tools_logo/javascript.svg", alt: "JavaScript" },
  { src: "/assets/tools_logo/css3.svg", alt: "CSS3" },
  { src: "/assets/tools_logo/angular.svg", alt: "Angular" },
  { src: "/assets/tools_logo/vue.svg", alt: "Vue.js" },
  { src: "/assets/tools_logo/flutter.svg", alt: "Flutter" },
  { src: "/assets/tools_logo/figma.svg", alt: "Figma" },
  { src: "/assets/tools_logo/laravel.svg", alt: "Laravel" },
  { src: "/assets/tools_logo/python.svg", alt: "Python" },
  { src: "/assets/tools_logo/firebase.svg", alt: "Firebase" },
  { src: "/assets/tools_logo/shopify.svg", alt: "Shopify" },
  { src: "/assets/tools_logo/wordpress.svg", alt: "WordPress" },
  { src: "/assets/tools_logo/bootstrap.svg", alt: "Bootstrap" },
];

const renderItem = (item) => <img src={item.src} alt={item.alt} loading="lazy" />;

const HomeLogoSlider = () => (
  <Slider
    items={items}
    renderItem={renderItem}
    speedDesktop="35s"
    speedMobile="28s"
    // label="Technologien, mit denen wir arbeiten"
  />
);

export default HomeLogoSlider;
